if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), productId: this.dataset.productId || null});
          this.error = false;
          let productId = this.dataset.productId ? String(this.dataset.productId) : null;
          if (!productId && response.items) {
            const variantId = formData.get('id');
            const added = response.items.find((i) => String(i.variant_id) === String(variantId));
            if (added) productId = String(added.product_id);
          }
          const quickAddModal = this.closest('quick-add-modal');
          const doRender = (resp) => {
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(resp); });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(resp);
            }
          };
          const cfg = window.freeGiftConfig || {};
          const triggerId = cfg.triggerProductId ? String(cfg.triggerProductId) : null;
          const freeVariantId = cfg.freeProductVariantId || 0;
          if (triggerId && freeVariantId && productId === triggerId && this.cart) {
            fetch('/cart.js').then((r) => r.json()).then((cart) => {
              if (cart.items.some((item) => item.variant_id === freeVariantId)) {
                doRender(response);
                return;
              }
              const fd = new FormData();
              fd.append('id', freeVariantId);
              fd.append('quantity', 1);
              const sections = this.cart.getSectionsToRender().map((s) => s.id);
              if (sections.length) {
                fd.append('sections', sections.join(','));
                fd.append('sections_url', window.location.pathname);
              }
              return fetch(window.routes?.cart_add_url || '/cart/add.js', {
                method: 'POST',
                body: fd,
                headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
              }).then((r) => r.json()).then((freeResp) => {
                doRender(freeResp && !freeResp.status && freeResp.sections ? freeResp : response);
              }).catch(() => doRender(response));
            }).catch(() => doRender(response));
          } else {
            doRender(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
